const EVENTS_URL = "https://vercel-visit-bot.vercel.app/api/track-events";
const VISITS_URL = "https://vercel-visit-bot.vercel.app/api/track-visits";
const TELEGRAM_PING_URL = "https://vercel-visit-bot.vercel.app/api/visit";

export const logVisit = async (payload) => {
  try {
    const gclid = sessionStorage.getItem("gclid") || null;

    const fullPayload = {
      ...payload,
      gclid,
    };

    const res = await fetch(VISITS_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(fullPayload),
    });
    const data = await res.json();

    // Optional: ping Telegram (non-blocking)
    fetch(TELEGRAM_PING_URL).catch(() => {});

    return data.visit_id || null;
  } catch (err) {
    console.warn("⚠️ Failed to log visit:", err);
    return null;
  }
};

export const logEvent = (type, payload = {}) => {
  const visit_id = sessionStorage.getItem("visitId");
  if (!visit_id) {
    console.warn("⚠️ No visitId found, skipping event log");
    return;
  }

  const data = { visit_id, type, payload };

  if (navigator.sendBeacon) {
    const blob = new Blob([JSON.stringify(data)], { type: "application/json" });
    navigator.sendBeacon(EVENTS_URL, blob);
  } else {
    fetch(EVENTS_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
      keepalive: true,
    }).catch((err) => {
      console.warn("⚠️ Failed to log event via fetch:", err);
    });
  }
};

export const trackCTA = (source) => {
  if (window?.fbq) {
    window.fbq("trackCustom", "CTA_Click", { source });
  }
  logEvent("CTA_Click", { source });
};

export const trackFormSubmission = (source = "quotePage") => {
  if (window?.fbq) {
    window.fbq("trackCustom", "QuoteFormSubmitted", { source });
  }
  logEvent("QuoteFormSubmitted", { source });
};

export const getFlagEmoji = (countryCode = "") => {
  if (!countryCode || countryCode.length !== 2) return "";
  return [...countryCode.toUpperCase()]
    .map((char) => String.fromCodePoint(127397 + char.charCodeAt()))
    .join("");
};

export const sendFormToTelegram = async ({
  name,
  contact,
  description,
  dateTime,
}) => {
  const city = sessionStorage.getItem("visitCity") || "Unknown City";
  const country = sessionStorage.getItem("visitCountry") || "Unknown Country";
  const countryCode = sessionStorage.getItem("visitCountryCode") || "";
  const gclid = sessionStorage.getItem("gclid") || null;

  const flag = getFlagEmoji(countryCode);
  const location = `${flag} *Location:* ${city}, ${country}`;
  const gclidLine = gclid ? `🔗 *GCLID:* \`${gclid}\`` : "🔗 *GCLID:* (none)";

  const message = `👤 *Name:* ${name}
📞 *Contact:* ${contact}
📝 *Project:* ${description}
📅 *Preferred time:* ${dateTime?.trim() || "(not specified)"}
${location}
${gclidLine}`;

  try {
    await fetch(
      "https://vercel-visit-bot.vercel.app/api/send-form-to-telegram",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message }),
      }
    );
    return true;
  } catch (err) {
    console.error("⚠️ Failed to send message to Telegram:", err);
    return false;
  }
};

export const sendLeadToSupabase = async ({
  name,
  contact,
  description,
  dateTime,
}) => {
  const visit_id = sessionStorage.getItem("visitId") || null;
  const city = sessionStorage.getItem("visitCity") || "Unknown City";
  const country = sessionStorage.getItem("visitCountry") || "Unknown Country";
  const country_code = sessionStorage.getItem("visitCountryCode") || "";
  const gclid = sessionStorage.getItem("gclid") || null;

  const payload = {
    visit_id,
    name,
    contact,
    description,
    preferred_time: dateTime?.trim() || "(not specified)",
    city,
    country,
    country_code,
    gclid,
  };

  try {
    const res = await fetch(
      "https://vercel-visit-bot.vercel.app/api/save-lead",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      }
    );

    if (!res.ok) throw new Error("Non-200 response");
    return true;
  } catch (err) {
    console.error("⚠️ Failed to save lead to Supabase:", err);
    return false;
  }
};
